import "@source@/common/base.js";

"use strict";


$(function() {
  /* - */
});



// WEBPACK FOOTER //
// ./assets/scripts/expired.js